<template>
  <el-main>
    <settings />
  </el-main>
</template>

<script>
  /*
    feed settings wrapper
  */

  // components
  import Settings from './settings/Settings';

  export default {
    name: 'PageContent',
    components: {
      Settings
    },
  }
</script>
